import logUtil from 'utils/log'

const getPaddingTopSquadSelectorUtil = (props) => {
  logUtil('getPaddingTopSquadSelectorUtil').debug('props=', props)
  const {
    shouldShowPostSampleBanner,
    shouldShowTemporaryUnlockedSamplesBanner,
    shouldShowFastTrackExpiryBanner,
    isMediumScreen
  } = props

  let res
  if (shouldShowTemporaryUnlockedSamplesBanner && isMediumScreen) {
    res = 65
  } else if (shouldShowTemporaryUnlockedSamplesBanner) {
    res = 48
  } else if (shouldShowPostSampleBanner && isMediumScreen) {
    res = 95
  } else if (shouldShowPostSampleBanner) {
    res = 64
  } else if (shouldShowFastTrackExpiryBanner && isMediumScreen) {
    res = 119
  } else if (shouldShowFastTrackExpiryBanner) {
    res = 48
  }
  return res
}

export default getPaddingTopSquadSelectorUtil
